import { UserPreferences } from '@dto/preferences';
import { CompozzError } from '@dto/CompozzError';
import { BASE_URL } from './constants';
import { get, put } from './utils';

/**
 * Fetches every preferences document of the current user in the workspace
 * (one per object holding view folders), in a single call.
 */
export function fetchWorkspacePreferences(wsKey: string): Promise<UserPreferences[] | null | CompozzError> {
    const url = `${BASE_URL}/model/workspaces/${wsKey}/preferences`;
    return get<UserPreferences[]>(url);
}

/**
 * Replaces the preferences document of the current user for the object
 * (folder paths + view mapping). Returns the normalized saved document.
 */
export function saveObjectPreferences(
    wsKey: string,
    objKey: string,
    prefs: Pick<UserPreferences, 'viewFolders' | 'viewsByFolder'>
): Promise<UserPreferences | null | CompozzError> {
    const url = `${BASE_URL}/model/workspaces/${wsKey}/objects/${objKey}/preferences`;
    return put<UserPreferences>(url, prefs);
}
